import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from '../Code';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoFeaturesOfCustomsClearance extends Component {

    render() {
        const { featuresOfCustomsClearance } = this.props;
        const summary = getTitleSummary(featuresOfCustomsClearance)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Особенности таможенного оформления'],
                    rows: summary
                }}
                expanded={(featuresOfCustomsClearance.length !== 0) ? false : false}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Описание',
                        'Примечание',
                        'Нормативный документ'
                    ],
                    rows: featuresOfCustomsClearance.map(({ to_date = null, code = '', description = '', note = '', order, order_date, orders_info = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        <Code code={code} />,
                        description,
                        note,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}


function getTitleSummary(items) {
    if (items.length === 0) {
        return null
    }
    var result = []
    items.filter(function (item) { return item.order }).forEach(item => {
        if (result.length === 0) {
            result.push(item);
        }
        // else if (item.order !== result.slice(-1)[0].order){
        // else if (item.order !== result.slice(-1)[0].order && item.order_date !== result.slice(-1)[0].order_date){
        else if (!(result.find((element) => element.order === item.order && element.order_date === item.order_date))) {
            result.push(item);
        }
    })
    return result.length !== 0 ? result.map(({
        note = '',
        order, order_date, orders_info = null,
    }) => ([
        `${note}`,
        formatOrder(order, order_date, orders_info),
    ])) : items.slice(0, 1).map(({
        note = '',
        order, order_date, orders_info = null,
    }) => ([
        `${note}`,
        formatOrder(order, order_date, orders_info),
    ]))

}






// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoFeaturesOfCustomsClearance.js